var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavbarFixed'),_c('SectionHero'),_c('SectionTimeline'),_c('SectionFAQ'),_c('SectionSponsors'),_c('SectionTeam'),_c('media-gallery'),_c('SectionFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }